import React from "react";
import {Table} from "antd";
import {numberColumn, stringColumn} from "../../../helpers/commonColumns";
import GridActionIcon from "../../../components/GridActionIcon";
import DeleteOutlined from "@ant-design/icons/es/icons/DeleteOutlined";
import DeleteTwoTone from "@ant-design/icons/es/icons/DeleteTwoTone";
import {DATE_FORMAT} from "../../../constants/dateFormat";

const CompanyLicenceDatatable = ({licenceElements, removeLicenceElement}) => {

    const licenceColumns = [
        stringColumn('companyName', 'Company'),
        stringColumn('softwareProductElement', 'Product'),
        numberColumn('quantity', 'Quantity'),
        stringColumn('expiryLicenceAction', 'Expiry Action'),
        {
            title: 'Expiry Date',
            dataIndex: 'expiryDate',
            key: 'expiryDate',
            render: (expiryDate) => {
                return expiryDate && expiryDate.format(DATE_FORMAT)
            },
        },
        {
            title: 'Actions',
            key: 'action',
            width: 50,
            render: (text, record) => (
                <span><GridActionIcon key="remove"
                                      title='Remove'
                                      disabled={false}
                                      icon={<DeleteTwoTone twoToneColor={twoToneColor}/>}
                                      darkIcon={<DeleteOutlined/>}
                                      onClick={() => removeLicenceElement(record)}/></span>
            )
        }
    ];

    const twoToneColor = 'red';

    licenceColumns.push();

    return <Table dataSource={licenceElements} columns={licenceColumns} />;
};

export default CompanyLicenceDatatable;